import { Outlet } from "react-router-dom";
import { BrandPanel } from "../components/BrandPanel";
import { ThemeToggle } from "../components/ThemeToggle";
import { FadeIn } from "../components/motion/FadeIn";

export function AuthSplitLayout() {
  return (
    <div className="flex min-h-dvh lg:h-svh lg:min-h-svh lg:overflow-hidden">
      <BrandPanel />
      <div className="relative flex-1 min-w-0 min-h-dvh lg:min-h-0 overflow-y-auto bg-background px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
        {/* Background decorative blobs */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-primary/[0.03] blur-[100px]" />
          <div className="absolute -bottom-40 -left-40 h-[400px] w-[400px] rounded-full bg-accent/[0.02] blur-[100px]" />
        </div>

        <div className="absolute top-4 right-4 z-10">
          <ThemeToggle />
        </div>

        <FadeIn className="relative mx-auto w-full max-w-[480px] py-4 sm:py-6">
          <Outlet />
        </FadeIn>
      </div>
    </div>
  );
}
